import React from 'react';
import { Table } from 'semantic-ui-react';
import TableWrapper from '@/components/table/TableWrapper';
import MemberPermissionsTableHeader from './MemberPermissionsTableHeader';
import MemberPermissionsTableRows from './MemberPermissionsTableRows';

const MemberPermissionsTable = ({
  readStatus,
  permissionGroups,
  members,
  entity,
  fetchData,
  removeMember,
  allowAdd,
  allowRemove,
  allowSecure,
  error,
  onErrorDismiss,
  updatePermissions,
  children,
}) => (
  <TableWrapper className="aridhia-member-permissions-table" sticky>
    <MemberPermissionsTableHeader readStatus={readStatus} error={error} onErrorDismiss={onErrorDismiss}>
      {children}
    </MemberPermissionsTableHeader>
    <Table.Body>
      <MemberPermissionsTableRows
        allowAdd={allowAdd}
        allowRemove={allowRemove}
        allowSecure={allowSecure}
        entity={entity}
        fetchData={fetchData}
        items={members}
        onChange={updatePermissions}
        permissionGroups={permissionGroups}
        readStatus={readStatus}
        removeMember={removeMember}
      />
    </Table.Body>
  </TableWrapper>
);

export default MemberPermissionsTable;
